var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_coupon)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4C2.7835 4 2 4.7835 2 5.75V8.05C3.1046 8.05 4 8.9454 4 10.05C4 11.1546 3.1046 12.05 2 12.05V14.35C3.1046 14.35 4 15.2454 4 16.35C4 17.4546 3.1046 18.35 2 18.35V20.25C2 21.2165 2.7835 22 3.75 22H20.25C21.2165 22 22 21.2165 22 20.25V18.35C20.8954 18.35 20 17.4546 20 16.35C20 15.2454 20.8954 14.35 22 14.35V12.05C20.8954 12.05 20 11.1546 20 10.05C20 8.9454 20.8954 8.05 22 8.05V5.75C22 4.7835 21.2165 4 20.25 4H3.75ZM8 8.75H16C16.4142 8.75 16.75 9.0858 16.75 9.5C16.75 9.9142 16.4142 10.25 16 10.25H8C7.5858 10.25 7.25 9.9142 7.25 9.5C7.25 9.0858 7.5858 8.75 8 8.75ZM8 13.75H13C13.4142 13.75 13.75 14.0858 13.75 14.5C13.75 14.9142 13.4142 15.25 13 15.25H8C7.5858 15.25 7.25 14.9142 7.25 14.5C7.25 14.0858 7.5858 13.75 8 13.75Z",
    fill: "#404040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_coupon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/Coupon.6cbbc9d05ec21deb2c0f9abc4a270d43.svg";
export { ForwardRef as ReactComponent };